import { render, staticRenderFns } from "./puRetrunRedAccount.vue?vue&type=template&id=686693f2&scoped=true"
import script from "./puRetrunRedAccount.vue?vue&type=script&lang=js"
export * from "./puRetrunRedAccount.vue?vue&type=script&lang=js"
import style0 from "./puRetrunRedAccount.vue?vue&type=style&index=0&id=686693f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686693f2",
  null
  
)

export default component.exports